export default __webpack_public_path__ + "static/2.5.1/media/invoice.da087390.svg";